import styled from 'styled-components';

export const ContentWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.tableCell};
`;

export const ImageWrapper = styled.div``;

export const ExampleWidgetTitle = styled.p`
  text-align: center;
  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.text};
`;

export const ExampleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
